export default function IconCross(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" fill="currentColor" {...props}>
  <path d="m655.86,681.64l-155.86-154.69-155.86,154.69c-7.03,8.2-18.75,8.2-25.78,0-8.2-7.03-8.2-18.75,0-25.78l154.69-155.86-154.69-155.86c-8.2-7.03-8.2-18.75,0-25.78,7.03-8.2,18.75-8.2,25.78,0l155.86,154.69,155.86-154.69c7.03-8.2,18.75-8.2,25.78,0,8.2,7.03,8.2,18.75,0,25.78l-154.69,155.86,154.69,155.86c8.2,7.03,8.2,18.75,0,25.78-7.03,8.2-18.75,8.2-25.78,0Z"/>
</svg>;
}
